import { createContext } from "react";

interface IModalStateContext {}

export const ModalsStateContext = createContext<IModalStateContext>({});

interface IModalsDispatchContext {}

export const ModalsDispatchContext = createContext<IModalsDispatchContext>({});
